import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Stars01 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "stars01",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m6.5 13 .7845 1.5689c.2654.531.3982.7965.5755 1.0265a3 3 0 0 0 .5446.5446c.23.1773.4955.3101 1.0265.5755L11 17.5l-1.569.7845c-.5309.2654-.7964.3982-1.0264.5755a3 3 0 0 0-.5446.5446c-.1773.23-.31.4955-.5755 1.0265L6.5 22l-.7845-1.5689c-.2654-.531-.3982-.7965-.5755-1.0265a3 3 0 0 0-.5446-.5446c-.23-.1773-.4955-.3101-1.0265-.5755L2 17.5l1.569-.7845c.5309-.2654.7964-.3982 1.0264-.5755a3 3 0 0 0 .5446-.5446c.1773-.23.31-.4955.5755-1.0265L6.5 13ZM15 2l1.1786 3.0644c.282.7332.423 1.0999.6423 1.4082.1944.2733.4331.5122.7065.7065.3083.2193.675.3603 1.4082.6423L22 9l-3.0644 1.1786c-.7332.282-1.0999.423-1.4082.6423a2.9994 2.9994 0 0 0-.7065.7065c-.2193.3083-.3603.675-.6423 1.4082L15 16l-1.1786-3.0644c-.282-.7332-.423-1.0999-.6423-1.4082a2.9994 2.9994 0 0 0-.7065-.7065c-.3083-.2193-.675-.3603-1.4082-.6423L8 9l3.0644-1.1786c.7332-.282 1.0999-.423 1.4082-.6423a2.9998 2.9998 0 0 0 .7065-.7065c.2193-.3083.3603-.675.6423-1.4082L15 2Z"
    })
  }));
};
export default Stars01;